<template>
  <div class="bg-3">
    <Header bgClass="bg-brand-blue" />
    <div class="flex flex-col justify-between w-full ">
      <div class="flex-1 pt-[540px]">
      <img src="@/assets/bulb.png" alt="bulb" class="absolute left-0 top-36 w-[170px]" />
      <img src="@/assets/green-star.svg" alt="green star" class="absolute left-10 top-[360px]" />
      <img src="@/assets/yellow-star.svg" alt="green star" class="absolute right-10 top-56" />
      <img src="@/assets/blue-star.svg" alt="green star" class="absolute right-40 top-36" />
      <img src="@/assets/thumbsup.png" alt="thumbsup" class="absolute right-0 w-72 top-60" />
    </div>
    <div class="flex flex-col items-center justify-center p-8 mb-4 uppercase rounded-lg bg-brand-blue">
      <div class="w-full">
        <div class="font-serif text-center text-white text-[40px]">
      Thank You For <br/> Participating
    </div>
    <div class="w-full">
      <a href="/selena/participants/logout"  class="block w-full py-3 mt-4 font-serif text-2xl text-center text-black rounded-lg outline-none bg-brand-yellow btn">Logout</a>
    </div>
    </div>
    </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import useStatusCheck from '@/hooks/useStatusCheck';

export default {
  name: 'DoneView',
  components: {
    Header
  },
  setup() {
    useStatusCheck()
  }
}
</script>
<style scoped>
.bg-3 {
	background: url('@/assets/bg-3.png') no-repeat -6px 0 / cover;
	padding: 16px;
  position: relative;
}
</style>